/* created by CoolGuy on 2018/11/27 */
import React from 'react';
import intl from 'react-intl-universal';

export default ({ h, m, s, onClose, onClick }) => (
  <div className="red-pack-notification" onClick={onClick}>
    <img
      src={require('../../assets/redpack/small-red-pack.png')}
      className={'small-red-pack'}
      alt=""
    />
    <span>{intl.get('Count down')}</span>
    <div className="times">
      <div className="one-time">{h}</div> :<div className="one-time">{m}</div> :
      <div className="one-time">{s}</div>
    </div>
    <img
      onClick={e => {
        e.stopPropagation();
        onClose && onClose();
      }}
      src={require('../../assets/redpack/x-white.png')}
      className={'red-pack-x'}
      alt=""
    />
  </div>
);
